/**
 * ConcoursBf — Auth service (frontend)
 */
import apiClient from './apiClient';

export async function login(email, password) {
  return apiClient('/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

export async function register({
  email,
  password,
  pseudonym,
  lastName,
  firstName,
  acceptTerms,
  acceptPrivacy,
  referralCode,
}) {
  return apiClient('/register', {
    method: 'POST',
    body: JSON.stringify({
      email,
      password,
      pseudonym,
      lastName,
      firstName,
      acceptTerms,
      acceptPrivacy,
      referralCode,
    }),
  });
}

export async function getMe() {
  return apiClient('/me');
}

export async function resetPassword(email) {
  return apiClient('/reset-password', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

export async function confirmResetPassword(token, email, newPassword) {
  return apiClient('/reset-password/confirm', {
    method: 'POST',
    body: JSON.stringify({ token, email, newPassword }),
  });
}

export async function resendEmailVerification() {
  return apiClient('/email-verification/resend', { method: 'POST' });
}

export async function logout() {
  return apiClient('/logout', { method: 'POST' });
}
